import type { ReactNode } from 'react';

/**
 * One read-only «label over value» pair, to sit inside a `<dl>` grid. For data
 * the admin shows but does not edit (an alarm's timestamps, who pays a
 * subscription, a workshop's fiscal data).
 *
 * An empty value renders as «—» in the muted colour, so a field nobody filled in
 * reads as EMPTY and never as a blank gap — and, unlike a disabled input with a
 * placeholder, can not be mistaken for a value.
 */
const MUTED = 'text-text-sub dark:text-slate-400';

function isEmpty(value: ReactNode): boolean {
  return value === null || value === undefined || value === false || value === '';
}

export default function Fact({ label, children }: { label: string; children: ReactNode }) {
  const empty = isEmpty(children);
  return (
    <div className="min-w-0">
      <dt className={`text-[11px] font-semibold uppercase tracking-wider ${MUTED}`}>{label}</dt>
      <dd className={`text-sm break-words ${empty ? MUTED : 'text-text-main dark:text-white'}`}>
        {empty ? '—' : children}
      </dd>
    </div>
  );
}
